import React, { useState } from "react";
import "./GoldDiamond.css";
import { Helmet } from "react-helmet-async";
import seoMeta from "./seoMeta";
import ParallaxSection from '../components/ParallaxSection'
import LogoCarousel from "../components/LogoCarousel";
import SubBanner from "../components/SubBanner"
import HeartSection from "../components/Health/HeartSection";
import HeartBanner from "../components/Health/HeartBanner";
import SubStory from "../components/Health/SubStory"
import bgImage from "../Assets/Gold/just-make-jewelry.png";
import SubStone from "../components/Health/SubStone";
import SubFounder from "../components/Health/SubFounder";
import MedicalCareCarousel from "../components/Health/MedicalCareCarousel"
import founderPhoto from "../Assets/Gold/purity-and-certification.png";
import waveBg from "../Assets/background-wave.png";
import dotPattern from "../Assets/health/Ellipse 164.png";
import vcnrLogo from "../Assets/vcnr-logo-white.png";
import OutreachSection from "../components/Health/HealthcareCommunityOutreach";
import Img1 from "../Assets/Gold/private-apointments.png";
import Img2 from "../Assets/Gold/video-consultants.png";
import Img3 from "../Assets/Gold/jewelry-guide.png";
import TestimonialSlider from "../components/Health/TestimonialSlider";
import LeaderDivisionSection from "../components/Leadership/LeaderDivisionSection";
import VCNRContactHospitalBanner from "../components/Contact/VCNRContactHospitalBanner";
import LeaderBuildWithUs from "../components/Leadership/LeaderBuildWithUs";
import QuickAccessRow from "../components/Career/QuickAccessRow";
import testimonialbg from "../Assets//rock-bg.png"
import SubJoinSection from "../components/Health/SubJoinSection";
import doctorImage from "../Assets/contact/VCNR-hospital-Doctor.png";
import Subservicesmediacarousel from "../components/Health/Subservicesmediacarousel";
import hospitalImg from "../Assets/Gold/gold-collection.png";
import diagnosticsImg from "../Assets/Gold/Diamond-collection.png";
import instituteImg from "../Assets/Gold/bridal-collection.png";
import pharmacyImg from "../Assets/Gold/daily-collection.png";
import healthparksImg from "../Assets/Gold/custome-collection.png";
import diamond from "../Assets/Gold/Gold-banner-diamond.png";
import people from "../Assets/Gold/Gold-banner-hands.png";
import pulseLine from "../Assets/tech/pulse.png";
import TechClientsCollaborations from "../components/Tech/TechClientsCollaborations";
import doctorImage1 from "../Assets/tech/doctorImage1.png"
import SchoolCard from "../components/Foundation/SchoolCard";
import promise from "../Assets/Gold/promise.png"
import TechBanner from "../components/Tech/TechBanner";
import techbanner from "../Assets/Gold/Gold.png"
import GoldBanner from "../components/Foundation/GoldBanner";
import ComingSoon from "../components/ComingSoon";

const GoldDiamonds = () => {
  const meta = seoMeta["/Goldandiamonds"];
const logos = [
  { src: require('../Assets/LOGO/client1.png'), alt: 'Nestle' },
  { src: require('../Assets/LOGO/client2.png'), alt: 'Godrej' },
  { src: require('../Assets/LOGO/client3.png'), alt: 'Bajaj' },
  { src: require('../Assets/LOGO/client4.png'), alt: 'Reliance' },
  { src: require('../Assets/LOGO/client5.png'), alt: 'Safexpress' },
  { src: require('../Assets/LOGO/client6.png'), alt: 'JWL' },
  { src: require('../Assets/LOGO/client7.png'), alt: 'GIRIAS' },
  { src: require('../Assets/LOGO/client8.png'), alt: 'Nestle' },
    { src: require('../Assets/LOGO/client9.png'), alt: 'Denso' },
      { src: require('../Assets/LOGO/client10.png'), alt: 'Britania' },
        { src: require('../Assets/LOGO/client11.png'), alt: 'fsc' },
          { src: require('../Assets/LOGO/client12.png'), alt: 'ITC' },
            { src: require('../Assets/LOGO/client13.png'), alt: 'scope' },
            { src: require('../Assets/LOGO/client14.png'), alt: 'Flipkart' },
          ];
const paragraphs = [
    `VCNR Golds and Diamonds was born from the idea that jewelry is not just adornment, but a legacy passed through generations. We at VCNR, bring the same compassion, quality, and care into the world of fine jewelry.`,
    ` Each piece showcases our commitment to authenticity, purity, and meaningful design. From traditional gold pieces to contemporary diamond creations, we offer collections that suit every milestone and moment.`,
  ];
const paragraphs1 = [
  `We measure our success with the success stories of our patients. Through words, videos, and shared memories, We honor the strength of those who have healed with us. Their stories inspire our teams to go further.`
];
const paragraphs2 = [
  `As part of the VCNR family, are backed by trust built through years of service in healthcare and community development. With a customer-first approach, we ensure every interaction reflects integrity, respect, and excellence because our customers deserve nothing less.`,
 
`VCNR Golds and Diamonds stands for more than just jewelry, we stand for belief. We treat each of our customer with care and respect.`
]
  const healthcareCards = [
  { image: Img1 },
  { image: Img2 },
  { image: Img3 },
  { image: Img1 },
  { image: Img2 },
  { image: Img3 },
  { image: Img1 },
  { image: Img2 },
  { image: Img3 },
];
const quickAccessCards = [
  {
    title: "View All Collections",
    buttonText: "Download Recruitment Brochure",
    buttonLink: "#"
  },
  {
    title: "Locate Our Showroom",
    buttonText: "Referral Program Info",
    buttonLink: "#",
  },
  {
    title: "Inquire About Custom Orders",
    buttonText: "Contact VCNR HR Team",
    buttonLink: "#"
  },
  {
    title: "Download Product Catalogue (PDF)",
    buttonText: "Join Our WhatsApp Hiring Channel",
    buttonLink: "#"
  }
];

const aboutTestimonials = [
  {
    stars: 5,
    title: "Amazing Experience!",
    text: "The whole journey was seamless and smooth. Would recommend to everyone!",
    author: "Ravi Kumar",
    location: "India, Bangalore",
    img: "https://i.pravatar.cc/40?img=9",
  },
  {
    stars: 4,
    title: "Truly Professional",
    text: "The team was very helpful and knowledgeable. They guided us at every step and made sure we got the best outcome.",
    author: "Neha Patel",
    location: "India, Mumbai",
    img: "https://i.pravatar.cc/40?img=10",
  },
  {
    stars: 5,
    title: "Exceeded Expectations",
    text: "From the first call to the final delivery, everything was well-managed and executed beyond my expectations.",
    author: "Mohammed Irfan",
    location: "India, Hyderabad",
    img: "https://i.pravatar.cc/40?img=11",
  },
  {
    stars: 4,
    title: "Reliable Support",
    text: "Even after the service was completed, they stayed in touch and provided great support when needed.",
    author: "Divya Menon",
    location: "India, Kochi",
    img: "https://i.pravatar.cc/40?img=12",
  },
  {
    stars: 5,
    title: "Effortless Process",
    text: "The process was transparent and smooth. I didn’t feel stressed at all and was kept informed throughout.",
    author: "Ankit Sharma",
    location: "India, Delhi",
    img: "https://i.pravatar.cc/40?img=13",
  },
  {
    stars: 5,
    title: "Highly Recommended",
    text: "One of the best service providers I’ve come across. Their ethics, efficiency, and execution are remarkable.",
    author: "Kritika Jain",
    location: "India, Pune",
    img: "https://i.pravatar.cc/40?img=14",
  },
  {
    stars: 5,
    title: "Customer First Approach",
    text: "They truly put the customer first. Every need of ours was taken care of. Thank you for such a positive experience.",
    author: "Ramesh Babu",
    location: "India, Chennai",
    img: "https://i.pravatar.cc/40?img=15",
  },
  {
    stars: 4,
    title: "Smooth Collaboration",
    text: "We worked on a collaborative project and it went smoothly thanks to their clear communication and technical expertise.",
    author: "Sonal Kapoor",
    location: "India, Jaipur",
    img: "https://i.pravatar.cc/40?img=16",
  },
];

const servicesData = [
  {
    title: "Gold Jewelry",
    description: "Traditional and modern pieces crafted in certified 22KT and 24KT gold.",
    image: hospitalImg,
  },
  {
    title: "Diamond Jewelry",
    description: "Schools, scholarships, vocational training",
    image: diagnosticsImg,
  },
  {
    title: "Bridal Collection",
    description: "Self-help groups, leadership workshops",
    image: instituteImg,
  },
  {
    title: "Daily Wear",
    description: "Sustainable agriculture, water conservation",
    image: pharmacyImg,
  },
  {
    title: "Custom Creations",
    description: "Emergency aid, rehabilitation efforts",
    image: healthparksImg,
  },

];


  return (
    <>
    <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>
    <ComingSoon />
    {/* <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>
      <GoldBanner />

<ParallaxSection><SubStory
      title="From Gold Earring to Diamond Engagement Rings, We Present Beauty."
      subtitle="Where the Journey Started"
      paragraphs={paragraphs}
    /></ParallaxSection>
    <ParallaxSection><SubStone
  imageSrc={bgImage}
  heading={<>We don’t just make jewelry. <br /> We create heirlooms.</>}
  buttonText="About Us"
  onButtonClick={() => window.location.href = "/about"}
/></ParallaxSection>
<ParallaxSection><Subservicesmediacarousel
      title={<>Our Collections <br />Do Not Buy Gold & Diamond. Buy Legacy.</>}
      // subtitle="Do Not Buy Gold & Diamond. Buy Legacy."
      services={servicesData}
    /></ParallaxSection>
    <ParallaxSection>
      <SchoolCard
  schoolName={<>Purity & Certification<br />Authentic Gold & Diamond Store You Can Trust</>}
  description="Every VCNR Golds and Diamonds piece comes with complete transparency and assurance:"
  features={[
        "BIS Hallmarked 22KT and 24KT gold",
        "GIA/IGI certified diamonds",
        "Lifetime exchange and buyback policies",
        "Ethical sourcing and conflict-free stones",
        "Transparent billing and weight-based pricing Our commitment to honesty and excellence is at the heart of everything we do."
  ]}
  buttonText="Visit our Page"
  buttonLink="/school"
  schoolBgImage={founderPhoto}
/>

    </ParallaxSection>
    <ParallaxSection><OutreachSection
          title="In-Store Experience More Than a Store an Experience"
          cardsData={healthcareCards}
          buttonText="Book an Appointment"
          onButtonClick={() => window.alert("Volunteer form will open")}
        /></ParallaxSection>
        <ParallaxSection>
          <img src={promise} alt="promise" className="promise" />
    <SubStory
      title="Golds, Diamonds & 
Genuine Care"
      subtitle="Where the Journey Started"
      paragraphs={paragraphs2}
    /></ParallaxSection>
    
                <ParallaxSection><QuickAccessRow cards={quickAccessCards} /></ParallaxSection>
          <ParallaxSection><LogoCarousel logos={[...logos, ...logos]} /></ParallaxSection>
          
           */}

    </>
  );
};

export default GoldDiamonds;
